module.exports = __webpack_public_path__ + "img/20190929135126765.43eafcf2.jpg";